import { render, staticRenderFns } from "./ReportChat.vue?vue&type=template&id=8be3e1d8"
import script from "./ReportChat.vue?vue&type=script&lang=js"
export * from "./ReportChat.vue?vue&type=script&lang=js"
import style0 from "./ReportChat.vue?vue&type=style&index=0&id=8be3e1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports